import React from 'react';

export function SelectPage() {
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: '60%',
        overflowY: 'hidden',
      }}
    >
      <h1
        style={{
          fontFamily: 'Montserrat',
          fontWeight: 400,
          color: '#B3B3B3',
          fontSize: '1.5rem',
        }}
      >
        Escolha acima a opção de relatório que você que acessar...
      </h1>
    </div>
  );
}
